import { render, staticRenderFns } from "./BlogPostTemplateEditor.vue?vue&type=template&id=6b9b516a&"
import script from "./BlogPostTemplateEditor.vue?vue&type=script&lang=ts&"
export * from "./BlogPostTemplateEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports